import styled from 'styled-components';

export const Container = styled.div<{ $width: number }>`
  position: absolute;
  top: 50%;

  height: 3.2rem;
  width: ${({ $width }) => `${$width}px`};

  transform: translateY(-50%);
  background: ${({ theme }) => theme.palette.grey[100]};
  border-radius: ${({ theme }) => theme.spacing(2)};
  pointer-events: none;
`;
